// extracted by mini-css-extract-plugin
module.exports = {"container":"_1GwxWpQSSpOxPvEQr3c8wR","details":"riZ7BqqEiuuPXBoyoPH01"};